const RouteParam = Object.freeze({
  RESTAURANT_ID: 'restaurantId',
  RESERVATION_ID: 'reservationId',
} as const);

export default RouteParam;
